
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/calendar/jst/calendarNavigator';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  
  return "\n<span id=\"calendar_navigator_component\"></span>\n";
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n<button class=\"navigate_today btn\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.calendar_navigator")
  },data:data},helper ? helper.call(depth0, "calendar.calendar_navigator.today", "Today", options) : helperMissing.call(depth0, "t", "calendar.calendar_navigator.today", "Today", options)))
    + "</button>\n<span class=\"navigation_buttons\">\n  <button class=\"navigate_prev btn\">\n    <i class=\"icon-arrow-left\" style=\"vertical-align: middle\" aria-hidden=\"true\"></i>\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.calendar_navigator")
  },data:data},helper ? helper.call(depth0, "calendar.calendar_navigator.previous", "Previous", options) : helperMissing.call(depth0, "t", "calendar.calendar_navigator.previous", "Previous", options)))
    + "</span>\n  </button>\n  <button class=\"navigate_next btn\">\n    <i class=\"icon-arrow-right\" style=\"vertical-align: middle\" aria-hidden=\"true\"></i>\n    <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.calendar_navigator")
  },data:data},helper ? helper.call(depth0, "calendar.calendar_navigator.next", "Next", options) : helperMissing.call(depth0, "t", "calendar.calendar_navigator.next", "Next", options)))
    + "</span>\n  </button>\n</span>\n<h2 class=\"navigation_title\" tabindex=\"-1\"><span role=\"button\" class=\"navigation_title_text\" tabindex=\"0\"></span></h2>\n<span class=\"date_field_wrapper\">\n    <label class=\"screenreader-only\" id=\"calendar_navigation_date_accessible_label\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("calendar.calendar_navigator")
  },data:data},helper ? helper.call(depth0, "calendar.calendar_navigator.enter_navigation_date", "Enter the date you would like to navigate to.", options) : helperMissing.call(depth0, "t", "calendar.calendar_navigator.enter_navigation_date", "Enter the date you would like to navigate to.", options)))
    + "\n      "
    + escapeExpression((helper = helpers.datepickerScreenreaderPrompt || (depth0 && depth0.datepickerScreenreaderPrompt),options={hash:{},data:data},helper ? helper.call(depth0, "date", options) : helperMissing.call(depth0, "datepickerScreenreaderPrompt", "date", options)))
    + "\n    </label>\n    <input type=\"text\" name=\"start date\"\n           style=\"width: 100px;\" class=\"date_field\"\n           aria-labelledby=\"calendar_navigation_date_accessible_label\"\n           data-tooltip title=\""
    + escapeExpression((helper = helpers.accessibleDateFormat || (depth0 && depth0.accessibleDateFormat),options={hash:{},data:data},helper ? helper.call(depth0, "date", options) : helperMissing.call(depth0, "accessibleDateFormat", "date", options)))
    + "\"/>\n</span>\n";
  return buffer;
  }

  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.FEATURES)),stack1 == null || stack1 === false ? stack1 : stack1.instui_header), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  